import Vue from 'vue';
import _ from 'lodash';

import Calc1 from '@/user/pages/authorized/study/calc/calc1/Calc1.vue';
import Calc2 from '@/user/pages/authorized/study/calc/calc2/Calc2.vue';



/** 数学開始単元No */
const MATH_START_SECTION_NO = 24;

export default Vue.extend({

  name: 'Calc',

  components: {
    Calc1,
    Calc2,
  },

  computed: {
    calcComponent(): string {
      const sectionNo = Number(this.$route.query.sectionNo);
      return sectionNo < MATH_START_SECTION_NO ? 'Calc1' : 'Calc2';
    }
  },



});
